import { AsYouType, parsePhoneNumberFromString, type PhoneNumber } from 'libphonenumber-js/min';

export function parseDirectPhoneNumber(value: string): PhoneNumber | undefined {
  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue.length > 50) {
    return undefined;
  }

  const phone = parsePhoneNumberFromString(trimmedValue.replace(/\p{Zs}/gu, ' '), {
    defaultCountry: 'US',
    extract: false,
  });
  return phone?.isValid() && !phone.ext ? phone : undefined;
}

export function formatPhoneNumberAsYouType(value: string): string {
  // Preserve partial deletion rather than restoring punctuation during backspace.
  if (value[0] === '(' && value.length <= 4) {
    return value;
  }

  const formatted = new AsYouType('US').input(value);
  // Formatting must not discard a country code, extension, or extra digits.
  return value.replace(/[\s().-]/g, '') === formatted.replace(/[\s().-]/g, '') ? formatted : value;
}
